<nav class="breadcrumb" aria-label="Breadcrumb">
  <button type="button" class="back-link" (click)="homeClicked.emit()">
    <span class="back-icon" aria-hidden="true"></span>
    Zurück
  </button>
  <span class="title" aria-current="page">{{ title }}</span>
  @if (showInfoButton) {
    <app-v3-info-button
      [opensPage]="infoOpensPage"
      (pageClicked)="infoClicked.emit()"
    ></app-v3-info-button>
  }
</nav>
